const newSubtleLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.25" stroke-width="1.5"/><polygon stroke-width="0" points="11.57 6.8 7.83 13.33 11.1 13.33 9.23 18 17.17 10.53 13.15 10.53 16.23 6.8"/></svg>',
};

export { newSubtleLarge as default };
